import { Button, makeStyles, Typography } from "@material-ui/core"

const useStyles = makeStyles(({ spacing }) => ({
    btn: {
        width: "fit-content",
        borderRadius: "45px",
    },
    text: {
        padding: spacing(0.5),
        fontWeight: 800,
        fontSize: "24px",
        lineHeight: "29px",
        textTransform: "none"
    },
    containedText: {
        padding: spacing(0.5),
        color: "white",
        fontWeight: 800,
        fontSize: "20px",
        lineHeight: "25px",
        textTransform: "none"
    },
}));

const MainBtn = (props) => {

    const classes = useStyles()

    return (
        <Button variant={props.btn.variant} color={props.btn.color} className={classes.btn} >
            <Typography p="true" className={props.btn.variant === "contained" ? classes.containedText : classes.text} >{props.btn.text}</Typography>
        </Button>
    )
}

export default MainBtn
